import SEO from './composants/SEO';
import { SEO_PAGES } from './donnees/seoPages'; 
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './PageContact.css';
import logoComplet from './assets/logo-complet.png';
import { useAuth } from './AuthContext';
import Navigation from './composants/Navigation';
import PiedDePage from './composants/PiedDePage';
export default function PageContact() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [form, setForm] = useState({ nom: '', email: '', telephone: '', sujet: '', message: '' });
  const [envoye, setEnvoye] = useState(false);
  const [chargement, setChargement] = useState(false);
  const [erreur, setErreur] = useState('');

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async () => {
    if (!form.nom || !form.email || !form.message) {
      setErreur('Veuillez remplir les champs obligatoires.');
      return;
    }
    setErreur('');
    setChargement(true);
    try {
      await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          access_key: '1a0e5769-fe54-4c9c-a553-91070bf0e9d2',
          subject: `📩 Message PEFEP Site — ${form.sujet || 'Sans sujet'}`,
          from_name: 'PEFEP Site Contact',
          name: form.nom,
          email: form.email,
          telephone: form.telephone || 'Non fourni',
          sujet: form.sujet || 'Non précisé',
          message: form.message
        })
      });
      setEnvoye(true);
      setChargement(false);
    } catch {
      setErreur('Une erreur est survenue. Contactez-nous sur WhatsApp.');
      setChargement(false);
    }
  };

  return (
    <div className="contact-page">
<SEO {...SEO_PAGES.contact} />
      <Navigation />
      <section className="contact-hero">
        <div className="contact-hero-content">
          <div className="contact-badge">📞 Contactez-nous</div>
          <h1>Parlons de votre projet</h1>
          <p>Notre équipe est disponible pour répondre à toutes vos questions et vous accompagner vers la meilleure solution digitale.</p>
        </div>
      </section>

      <section className="contact-humain">
        <div className="contact-container">
          <div className="contact-badge-center">🤝 Vous avez besoin d'un expert humain ?</div>
          <h2>Pour les projets complexes, PEFEP Digital est là</h2>
          <p className="humain-intro">PEFEP Site génère automatiquement des sites grâce à l'IA. Mais pour les projets sur mesure, les systèmes complexes ou les packs digitaux complets, notre équipe humaine de <strong>PEFEP GROUPE</strong> prend en charge votre projet personnellement.</p>

          <div className="humain-grid">
            <div className="humain-card">
              <div className="humain-icon">⚙️</div>
              <h3>Projet Personnalisé</h3>
              <p>Système sur mesure, application web, fonctionnalité spéciale ou site complexe qui nécessite l'intervention d'un développeur expert.</p>
              <ul className="humain-liste">
                <li>✅ Système de gestion personnalisé</li>
                <li>✅ Application web sur mesure</li>
                <li>✅ Intégrations complexes</li>
                <li>✅ E-commerce avancé</li>
              </ul>
              <a href="https://pefepgroupe.digital/demande-de-projet-personnalise/" target="_blank" rel="noopener noreferrer" className="humain-btn">
                🚀 Faire une demande de projet →
              </a>
            </div>

            <div className="humain-card featured">
              <div className="humain-badge-top">⭐ Offre complète</div>
              <div className="humain-icon">📦</div>
              <h3>Pack Digital Complet</h3>
              <p>Transformation digitale complète pour votre entreprise — site web, SEO, réseaux sociaux, design et accompagnement stratégique.</p>
              <ul className="humain-liste">
                <li>✅ Site web professionnel</li>
                <li>✅ Google Business Profile</li>
                <li>✅ 4 profils réseaux sociaux</li>
                <li>✅ Design pack complet</li>
                <li>✅ Domaine + hébergement 1 an</li>
                <li>✅ 2 sessions de coaching</li>
              </ul>
              <a href="https://pefepgroupe.digital/pack-digital/" target="_blank" rel="noopener noreferrer" className="humain-btn featured-btn">
                📦 Découvrir le Pack Digital →
              </a>
            </div>
          </div>

          <div className="humain-note">
            <span>💡</span>
            <p>Ces services sont assurés par l'équipe humaine de <strong>PEFEP Digital</strong>, l'agence mère de PEFEP Site. Pour les projets simples et rapides, restez sur <strong>PEFEP Site</strong> — notre IA s'occupe de tout !</p>
          </div>
        </div>
      </section>

      <section className="contact-form-section">
        <div className="contact-container">
          <div className="contact-grid">

            <div className="contact-infos">
              <h2>Nos coordonnées</h2>
              <p>Pour toute question sur PEFEP Site, notre équipe vous répond rapidement.</p>
              <div className="contact-info-card">
                <span className="info-icon">📱</span>
                <div>
                  <h4>WhatsApp</h4>
                  <p>+509 4737 6200</p>
                  <p>+509 4032 5735</p>
                </div>
              </div>
              <div className="contact-info-card">
                <span className="info-icon">✉️</span>
                <div>
                  <h4>Email</h4>
                  <p>contact@pefep.site</p>
                </div>
              </div>
              <div className="contact-info-card">
                <span className="info-icon">🌐</span>
                <div>
                  <h4>Sites web</h4>
                  <p>pefep.site</p>
                  <p>pefepgroupe.digital</p>
                </div>
              </div>
              <div className="contact-info-card">
                <span className="info-icon">🕐</span>
                <div>
                  <h4>Disponibilité</h4>
                  <p>Lundi — Samedi</p>
                  <p>8h00 — 18h00</p>
                </div>
              </div>
              <div className="contact-info-card">
                <span className="info-icon">📍</span>
                <div>
                  <h4>Adresse</h4>
                  <p>134, Rue Georges Kernizan</p>
                  <p>Léogâne, Haïti</p>
                </div>
              </div>
            </div>

            <div className="contact-form">
              <h2>Envoyez-nous un message</h2>
              <p>Nous vous répondrons dans les 24 heures ouvrables.</p>

              {envoye ? (
                <div className="contact-succes">
                  <div className="succes-icon">✅</div>
                  <h3>Message envoyé !</h3>
                  <p>Merci {form.nom} ! Nous vous répondrons sur <strong>{form.email}</strong> dans les plus brefs délais.</p>
                  <button type="button" className="contact-btn-retour" onClick={() => { setEnvoye(false); setForm({ nom: '', email: '', telephone: '', sujet: '', message: '' }); }}>
                    Envoyer un autre message
                  </button>
                </div>
              ) : (
                <div className="contact-form-inner">
                  {erreur && <div className="contact-erreur">⚠️ {erreur}</div>}
                  <div className="form-row">
                    <div className="form-field">
                      <label>Nom complet *</label>
                      <input type="text" name="nom" placeholder="Ex: Jean-Pierre Michel" value={form.nom} onChange={handleChange} />
                    </div>
                    <div className="form-field">
                      <label>Email *</label>
                      <input type="email" name="email" placeholder="Ex: contact@monentreprise.com" value={form.email} onChange={handleChange} />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-field">
                      <label>WhatsApp <span className="opt">(optionnel)</span></label>
                      <input type="text" name="telephone" placeholder="+509 4737 6200" value={form.telephone} onChange={handleChange} />
                    </div>
                    <div className="form-field">
                      <label>Sujet <span className="opt">(optionnel)</span></label>
                      <input type="text" name="sujet" placeholder="Ex: Question sur les tarifs" value={form.sujet} onChange={handleChange} />
                    </div>
                  </div>
                  <div className="form-field full">
                    <label>Votre message *</label>
                    <textarea name="message" placeholder="Décrivez votre question ou votre projet..." rows={6} value={form.message} onChange={handleChange} />
                  </div>
                  <button type="button" className="contact-submit" onClick={handleSubmit} disabled={chargement}>
                    {chargement ? '⏳ Envoi en cours...' : '📩 Envoyer le message'}
                  </button>
                  <p className="contact-note">Pour une réponse rapide, contactez-nous sur WhatsApp au <strong>+509 4737 6200</strong>.</p>
                </div>
              )}
            </div>

          </div>
        </div>
      </section>
<PiedDePage />
    </div>
  );
}